import React, { useState } from "react";
import { Gift, X } from "lucide-react";
import { claimDailyCrate } from "../game/authService";
import { useAuth } from "../contexts/AuthContext";
import { playClick, playPurchase } from "../game/sound";

// Modal triggered from the Menu when a VIP player taps the daily crate
// button. The reward is rolled by the backend (server-side fairness).
export default function DailyCrateModal({ onClose }) {
  const { refresh } = useAuth();
  const [reward, setReward] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const claim = async () => {
    setBusy(true);
    setErr("");
    try {
      const r = await claimDailyCrate();
      setReward(r);
      playPurchase();
      await refresh();
    } catch (e) {
      setErr(e?.response?.data?.detail || "Could not claim crate");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="reward-overlay" data-testid="daily-crate-modal">
      <div className="reward-card-wrap" style={{ maxWidth: 480 }}>
        <button
          type="button"
          className="zc-btn icon-back"
          style={{ position: "absolute", top: 16, right: 16, left: "auto" }}
          onClick={() => { playClick(); onClose(); }}
          data-testid="crate-close"
        >
          <X size={18} />
        </button>
        <div className="reward-header">
          <div className="reward-eyebrow">VIP DAILY CRATE</div>
          <h2 className="reward-title">
            <Gift size={28} style={{ verticalAlign: "middle", marginRight: 6 }} />
            Your gift
          </h2>
        </div>
        {!reward && !err && (
          <div style={{ textAlign: "center", padding: "16px 0" }}>
            <button
              type="button"
              className="zc-btn primary big"
              disabled={busy}
              onClick={claim}
              data-testid="claim-crate"
            >
              {busy ? "Opening…" : "Open today's crate"}
            </button>
          </div>
        )}
        {reward && (
          <div className="crate-reward" data-testid="crate-reward">
            <div className="crate-reward-icon"><Gift size={52} /></div>
            <div className="crate-reward-label">{reward.label}</div>
            <button type="button" className="zc-btn primary" onClick={onClose}>
              Sweet
            </button>
          </div>
        )}
        {err && (
          <div style={{ textAlign: "center", color: "#ff9090", marginTop: 12 }}>
            {err}
            <div style={{ marginTop: 10 }}>
              <button type="button" className="zc-btn" onClick={onClose}>Close</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
